import axios from 'axios';

export default {
  fetchDepartmentList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/department', {
      params: paginationParams,
    })
      .then((departments) => {
        commit('setData', departments);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteDepartment(_, department) {
    return axios.delete(`/department/${department.id}`);
  },
};
